import React from 'react';
import PropTypes from 'prop-types';
import * as types from '../../../constants/actionTypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from '../../../actions/brandActions';
import { actions as navigationActions } from '../../../actions/navigationActions';
import BrandForm from '../Identifiers/locationBrandForm';
import { DEFAULT_PAGE_SIZE } from '../../../constants/constants';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import Drawer from '../../Common/Drawer/Drawer';
import Icon from '../../Common/Icon';
import Notification from '../../../components/Common/Notification';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import { getDataTableSortFields, getSearchParamSortFields } from '../../../helpers/sortHelper';
import { getNullableOnChangeValue } from '../../../helpers/multiselect';
import './locationBrand.scss';

export class Brand extends React.Component {

    constructor(props, context) {
        super(props, context);

        const newBrand = {
            id: 0,
            name: "",
            isActive: true,
            subscriptionId: props.subscriptionId,
            backgroundColor: "",
            logoBytes: null,
            logoFileName: ''
        };

        this.state = {
            brands: [],
            totalCount: 0,
            selectedBrand: newBrand,
            editBrand: newBrand,
            newBrand: newBrand,
            drawerOpen: false,
            isFormValid: true,
            isFetching: false,
            isSaving: false,
            errorMessage: "",
            fileToUpload: null,
            searchParams: {
                subscriptionId: props.subscriptionId,
                isActive: true,
                pageSize: DEFAULT_PAGE_SIZE,
                pageNumber: 1,
                sortBy: "name",
                sortDir: "asc",
                name: ""
            }
        };
        this.search.bind(this);
    }

    async componentDidMount() {
        await this.search();
    }

    async search() {
        try {
            this.setState({ isFetching: true });
            const result = await this.props.actions.searchBrands(this.state.searchParams);
            const payload = result.payload;
            if (result.type === types.SEARCH_BRAND_SUCCESS) {
                this.setState({ brands: payload.results, totalCount: payload.totalCount });
            } else if (result.type === types.SEARCH_BRAND_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isFetching: false });
        }
    }

    async save() {
        this.setState({ isSaving: true });
        const result = await this.props.actions.saveBrand(this.state.editBrand, this.state.fileToUpload)

        if (result.type === types.CREATE_BRAND_SUCCESS || result.type === types.UPDATE_BRAND_SUCCESS) {
            Notification("success", "Save Successful", "Brand saved successfully")
            this.setState({ drawerOpen: false, fileToUpload: null });
            this.setState({ searchParams: { ...this.state.searchParams, pageNumber: 1 } }, () => {
                this.search();
            });

            if (result.type === types.UPDATE_BRAND_SUCCESS) {
                try {
                    // Cause navigation info to reload, in case the current location's brand logo was just modified
                    const request = {
                        subscriptionId: this.props.subscriptionId,
                        locationKey: this.props.locationKey
                    }
                    this.props.navigationActions.info(request);
                } catch (error) {
                    // swallow, so it doesn't hurt brand experience
                }
            }
        } else if (result.type === types.UPDATE_BRAND_FAILURE || result.type === types.CREATE_BRAND_FAILURE) {
            this.setState({ errorMessage: result.payload.message });
            Notification("error", "An Error Occurred", result.payload.message)
        }
        this.setState({ isSaving: false });
    }

    filterNameChange = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, name: e.target.value } });
    }

    keyUpName = (e) => {
        if (e.keyCode == 13) {
            this.search();
        }
    }

    onSearchBlur = () => {
        this.search();
    }

    onActiveChange = (e) => {
        const selectedValue = getNullableOnChangeValue(e);
    
        this.setState(prevState => ({
            searchParams: {
                ...prevState.searchParams,
                isActive: selectedValue
            }
        }), () => {
            this.search();
        });
    }

    onPageChange = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, pageNumber: (e.page + 1) } }, () => {
            this.search();
        });
    }

    onAddNew = () => {
        this.setState({ selectedBrand: null, editBrand: this.state.newBrand, drawerOpen: true, isFormValid: true, fileToUpload: null });
    }

    // ------- Form Changes

    onFormChange = (name, value) => {
        this.setState({ editBrand: { ...this.state.editBrand, [name]: value } });
    }
    onLogoChange = (file) => {
        this.setState({ fileToUpload: file });
    }

    // ------- Form Changes



    // ------- Drawer
    saveClick = () => {
        const trimmedName = this.state.editBrand.name.trim();
    
        if (trimmedName.length < 1) {
            this.setState({ isFormValid: false });
            return false;
        }
    
        this.setState(prevState => ({
            isFormValid: true,
            editBrand: {
                ...prevState.editBrand,
                name: trimmedName
            }
        }), this.save); // Ensure `save()` runs after state updates
    
        return false;
    }
    

    cancelClick = () => {
        this.setState({ drawerOpen: false });
    }

    selectBrand = (e) => {
        const newValue = e.value || this.state.selectedBrand;
        this.setState({ selectedBrand: newValue, editBrand: newValue, drawerOpen: true, isFormValid: true });
    }
    // ------- Drawer

    actionTemplate = (rowData) => {
        if (rowData.isActive) {
            return <div className="text-success text-center"><Icon name="check-circle" /></div>;
        } else {
            return <div className="text-danger text-center"><Icon name="times-circle" /></div>;
        }
    }

    logoTemplate = (rowData) => {

        const bg = (rowData.backgroundColor) ? rowData.backgroundColor : "white";

        if (rowData.logoUrl && rowData.logoUrl.trim().length > 0) {
            return <div className="logo-wrapper" style={{ backgroundColor: bg }}><img src={rowData.logoUrl} alt="logo" /></div>;
        } else if (rowData.logoCustomerFileId && !rowData.logoUrl) {
            // If logo is expected, but not found, show an error indicator in cell
            return <span className="logo-failed" title="Failed to load brand logo"><Icon name="times-circle" /></span>
        } else {
            // If no logo is set, show nothing
            return null;
        }
    }

    onSort = ({ sortField, sortOrder }) => {
        const { sortBy, sortDir } = getSearchParamSortFields(sortField, sortOrder);
        if (sortBy !== this.state.searchParams.sortBy || sortDir !== this.state.searchParams.sortDir) {
            this.setState({
                searchParams: {
                    ...this.state.searchParams,
                    sortBy: sortBy,
                    sortDir: sortDir
                }
            }, this.search);
        }
    }

    render() {

        const displayColumns = (this.props.windowWidth < 500) ? 'none' : '';

        const activeOptions = [
            { label: "Yes", value: true },
            { label: "No", value: false },
            { label: "All", value: null }
        ];
        
        const activeFilter = (
            <Dropdown
                className="ui-column-filter"
                value={this.state.searchParams.isActive}
                options={activeOptions}
                optionLabel="label"
                optionValue="value"
                onChange={this.onActiveChange}
                placeholder="Select an option"
            />
        );

        const nameFilterElement =
            <input type="text" className="p-inputtext" placeholder="Filter by Name" size="50" onBlur={this.onSearchBlur} onChange={this.filterNameChange} onKeyUp={this.keyUpName} value={this.state.searchParams.name} />
        ;

        const { sortField, sortOrder } = getDataTableSortFields(this.state.searchParams);

        return (
            <div>
                {
                    this.state.drawerOpen
                        ?
                        <Drawer isWide={false} title="Brand" onSaveClick={this.saveClick} onCancelClick={this.cancelClick}>
                            <BrandForm
                                brand={this.state.editBrand}
                                onFormChange={this.onFormChange}
                                isFormValid={this.state.isFormValid}
                                onLogoChange={this.onLogoChange}
                                onSubmit={this.saveClick} />
                        </Drawer>
                        :
                        null
                }
                <LoadingIndicator isLoading={this.state.isFetching || this.state.isSaving} hideWhileLoading={true}>
                    <div>
                        <div className="identifier-header">
                            <div className="title">Brand</div>
                            <div className="close">
                                <button type="button" onClick={this.props.onClose} alt="close popup"><Icon name="times" /></button>
                            </div>
                        </div>

                        <div className="identifier-add-new">
                            <div className="col-sm-12">
                                <button type="button" className="btn btn-primary" onClick={this.onAddNew} alt="close popup"><span className="me-2">Add New</span><Icon name="plus-circle" /></button>
                            </div>
                        </div>

                        <div className="identifier-results-table">
                            <DataTable
                                filterDisplay="row"
                                className="p-datatable-sm p-datatable-striped"
                                value={this.state.brands}
                                selectionMode="single"
                                selection={this.state.selectedBrand}
                                onSelectionChange={this.selectBrand}
                                sortField={sortField}
                                sortOrder={sortOrder}
                                onSort={this.onSort}
                                >
                                <Column field="name" sortable={true} header="Name" filter={true} filterElement={nameFilterElement} />
                                <Column field="backgroundColor" sortable={true} header="Background Color" style={{ display: displayColumns }} />
                                <Column field="logo" header="Logo" body={this.logoTemplate} style={{ display: displayColumns, width: '210px', textAlign: 'center' }} />
                                <Column field="isActive" sortable={true} header="Active" body={this.actionTemplate} style={{ width: '120px' }} filter={true} filterElement={activeFilter} />
                            </DataTable>
                            {
                                this.state.totalCount > this.state.searchParams.pageSize &&
                                <Paginator
                                    rows={this.state.searchParams.pageSize}
                                    totalRecords={this.state.totalCount}
                                    first={(this.state.searchParams.pageNumber - 1) * this.state.searchParams.pageSize}
                                    onPageChange={this.onPageChange} />
                            }
                            <div className="results-count">Total records: {this.state.totalCount}</div>
                        </div>
                    </div>

                </LoadingIndicator>
            </div>
        );
    }

}

Brand.propTypes = {
    windowWidth: PropTypes.number.isRequired,
    subscriptionId: PropTypes.number.isRequired,
    actions: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    navigationActions: PropTypes.object.isRequired,
    locationKey: PropTypes.string.isRequired,
}

function mapStateToProps(state) {
    let locationKey = '';
    if (state.taskListState.searchParams
        && state.taskListState.searchParams.locationKeys
        && state.taskListState.searchParams.locationKeys.length) {
        // Try grabbing the first key set in the task lists redux search params
        locationKey = state.taskListState.searchParams.locationKeys[0];
    }

    return {
        windowWidth: state.window.width,
        locationKey: locationKey
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Brand);

